export enum ComparisionCycle {
  YEAR = 'YEAR',
  HALF_YEAR = 'HALF_YEAR',
  QUARTER = 'QUARTER',
  MONTH = 'MONTH',
}
